export default {
    welcome: 'Welcome to the',
    title: 'Please set your new password',
    password1: {
        label: 'New password',
        error: {
            required: 'Please enter your new password',
            max: 'Maximal length is 255 chars',
            complex: 'Unfortunately, the password does not meet the criterias (please see below)'
        }
    },
    password2: {
        label: 'Confirm new password',
        error: {
            required: 'Please confirm your new password',
            same: 'Both passwords must be identical'
        }
    },
    poweredby: 'Powered by <strong>Trendexplorer</strong>, a product of &copy; <em>TRENDONE GmbH</em>',
    pageTitle: 'PASSWORD FORGOTTEN - NEW PASSWORD'
}
